<template>
  <div class="child-platform">
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="startSearch"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      ></Table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <editForm
        ref="editForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
  </div>
</template>
<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { systemApi } from "../../../../api-path/system-api.js";

export default {
  name: "allUsers",
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      switchVal: false,
      isEdit: false,
      title: "",
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入名称/key/security",
          },
        ],
      },
      searchParams: {
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            this.title = "新增";
            this.isEdit = false;
            this.ruleForm = {
              areaIds: "",
              id: "",
              name: "",
              comKey: "",
              comSecurity: "",
              areaName: "",
            };
            this.dialogVisible = true;
          },
        },
      ],
      dialogVisible: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: false,
        checkboxFn: (data) => {
          console.log(data);
        },
        rows: [
          {
            label: "应用名称",
            prop: "name",
          },
          {
            label: "三方平台ID",
            prop: "id",
          },
          {
            label: "key",
            prop: "comKey",
          },
          {
            label: "security",
            prop: "comSecurity",
          },
          {
            label: "授权时间",
            prop: "createGmt",
          }
        ],
        rowButtons: {
          width: "200px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.ruleForm = data;
                this.title = "编辑";
                this.isEdit = true;
                this.dialogVisible = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("确认删除该条数据?", "删除", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .get(`${systemApi.platformAppDel}?id=${data.id}`)
                      .then((res) => {
                        if (res.status === 200) {
                          this.$message({
                            type: "success",
                            message: "操作成功",
                          });
                          this.startSearch();
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消操作",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页

      //formConfig
      ruleForm: {
        areaIds: "",
        id: "",
        name: "",
        comKey: "",
        comSecurity: "",
        areaName: "",
        url:"",
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入应用名称",
          },
        ],
        comKey: [
          {
            required: true,
            trigger: "change",
            message: "请输入key",
          },
        ],
        comSecurity: [
          {
            required: true,
            trigger: "change",
            message: "请输入security",
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: "请选择区域",
          },
        ],
      },
      formConfig: {
        disabled: false,
        ref: "rtspform",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "应用名称",
              key: "name", // 数据名称
              prop: "name", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入应用名称", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "key",
              key: "comKey", // 数据名称
              prop: "comKey", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入key", // 提示信息
            },
            {
              valueType: "button", // 类型
              label: "生成",
              type: "primary",
              marginLeft: "0px 0px 0px 18px",
              itemWidth: "10%",
              fn: () => {
                //选择的值
                this.$http.get(systemApi.platformAppCreateKeyInfo).then((res) => {
                  if (res.status == 200) {
                    this.ruleForm.comKey = res.result;
                  }
                });
              },
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "security",
              key: "comSecurity", // 数据名称
              prop: "comSecurity", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "50%",
              placeholder: "请输入security", // 提示信息
            },
            {
              valueType: "button", // 类型
              label: "生成",
              type: "primary",
              marginLeft: "0px 0px 0px 18px",
              itemWidth: "10%",
              fn: () => {
                //选择的值
                this.$http.get(systemApi.platformAppCreateKeyInfo).then((res) => {
                  if (res.status == 200) {
                    this.ruleForm.comSecurity = res.result;
                  }
                });
              },
            },
          ],
          [
            {
              valueType: "tree-selected", // 类型
              label: "授权区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "80%",
              placeholder: "请选择注册区域", // 提示信息
              fn: (data) => {
                //选择的值
                this.ruleForm.areaIds = data.id;
                this.ruleForm.areaName = data.name;
              },
            },
          ],

          [
            {
              valueType: "input", // 类型
              label: "回调地址",
              key: "url", // 数据名称
              prop: "url", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              placeholder: "请输入回调地址", // 提示信息
            },
          ],


        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              let params = JSON.parse(JSON.stringify(data));
              this.$http.post(systemApi.platformAppSave, params).then((res) => {
                if (res.status == 200) {
                  this.$message.success(this.title + "成功！");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
            },
          },
          {
            type: "back", // 重置
            fn: () => {
              this.dialogVisible = false;
            },
          },
        ],
      },
    };
  },

  mounted() {
    this.startSearch();
  },
  methods: {
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.ruleForm.areaId = node.id;
      this.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.searchParams.search = "";
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.startSearch();
    },

    startSearch() {
      this.$http
        .get(systemApi.platformAppList, { params: this.searchParams })
        .then((res) => {
          if (res.status == 200) {
            let data = res.result.pageList;
            this.tableTemplateData = data;
            this.pagination.total = res.result.total;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.child-platform {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
